module.exports = __webpack_public_path__ + "static/media/smiley.d9cc56d5.png";